import { contactPage } from "../content/pagesContent";

export function contactRequestPayload(formData, captchaToken) {
  const payload = Object.fromEntries(formData.entries());
  delete payload["cf-turnstile-response"];
  payload.captchaToken = captchaToken;
  return payload;
}

export async function contactFailureMessage(response) {
  const result = await response.json().catch(() => ({}));
  return typeof result.error === "string" && result.error.trim() ? result.error : contactPage.failure;
}
